import { useQuery } from '@tanstack/react-query';
import { fetchMembersForGroups } from '../../api/groupMembers';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

const NONE = [];

/** Members of every group in `groupIds` (the Find picker's people, the card's counts). */
export function useGroupsMembers(userId, groupIds) {
  const key = [...(groupIds ?? [])].sort();
  return useQuery({
    queryKey: queryKeys.find.members(userId, key),
    queryFn: () => fetchMembersForGroups(key),
    enabled: Boolean(userId) && key.length > 0,
    staleTime: STALE.user,
    select: (data) => data ?? NONE,
  });
}
